var map = {
	"./amsa/SolicitudesMateriales": [
		"fS46",
		20
	],
	"./collahuasi/SolicitudesMateriales": [
		"6D24",
		18
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "sMxZ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/pages/cataloger lazy ^\.\/.*\/SolicitudesMateriales$
// module id = sMxZ
// module chunks = 41